import styled from 'styled-components';
import { ModalBody } from 'design-system/src/components/Modal';

export const MODAL_CONTENT_GAP = '4px';

export const ModalContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${MODAL_CONTENT_GAP};
`;

export const ModalFormRow = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`;

export const ModalFormRowWithButton = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: row;
  align-items: flex-start;
`;

export const ModalFieldContainer = styled.div`
  flex: 1;
`;

export const ModalAddButtonContainer = styled.div`
  display: flex;
  // This padding helps align the button with the form inputs on the same row
  // The padding needs to match the height of the labels on top of the form inputs
  padding-top: 23px;
`;

export const StyledModalBody = styled(ModalBody)`
  height: 400px;
`;
